import { BestOfRingVideo } from '@amzn/ring-neighbors-contentful-gql-schema';
import { useCallback, useMemo } from 'react';
import { useBestOfRingPage } from 'src/features/BestOfRing/hooks/useBestOfRingPage';

export const useGetBestOfRingContextValue = () => {
  const { data, loading } = useBestOfRingPage();
  const { videosCollection, ...gallery } = data! || {};

  const videoList: BestOfRingVideo[] = useMemo(() => {
    const videos: BestOfRingVideo[] = [];

    if (!videosCollection) return videos;

    for (const video of videosCollection?.items) {
      videos.push(video as BestOfRingVideo);
    }

    return videos;
  }, [videosCollection]);

  const getVideoCollectionById = useCallback(
    (id: string) => {
      for (const video of videoList) {
        if (video?.sys.id === id) return video;
      }
      return null;
    },
    [videoList],
  );

  return {
    gallery,
    videoList,
    getVideoCollectionById,
    loading,
  };
};
